<template>
  <div style="position: relative;" :style="mainStyle">
    <div class="taxiAcsc-page" :style="mainStyle">
      <img v-if="lang == 'zh'" src="../../images/banner_2_zh.png" class="w-f">
      <img v-else-if="lang == 'km'" src="../../images/banner_2_km.png" class="w-f">
      <img v-else src="../../images/banner_2_en.png" class="w-f">
      <span class="flex-xy-center taxiAcsc-page-title">{{ $root.getText('congratulations') }}</span>

      <RuleDialog :data="ruleData"></RuleDialog>

      <span class="taxiAcsc-page-subtitle">
        <span>{{ $root.getText('successfully') }}</span>
      </span>

      <div class="taxiAcsc-page-abaw flex-xy-center">
        <div class="taxiAcsc-page-aba flex-xy-center">{{ $root.getText('abaPayOnly') }}</div>
      </div>

      <div
        class="taxiAc-coupon-item"
        v-for="(item, $index) in couponList"
        :key="$index"
      >
        <div class="taxiAc-coupon-amount" v-if="isAmount(item)">
          <strong>{{ numFormat(item.couponAmt, item.currency) }}</strong>
          <span>{{ item.currency  }}</span>
        </div>
        <div class="taxiAc-coupon-amount" v-else>
          <strong>{{ item.preferRatio }}%</strong>
          <span>OFF</span>
          <div v-if="item.preferLimitUsd" class="taxiAc-coupon-preferLimit flex-icenter">{{ $root.getText('upTo', { value: moneyFormat(item.preferLimitUsd, item.currency) }) }}</div>
        </div>
        <div class="taxiAc-coupon-text">{{ item.couponTitle || 'Coupon' }}</div>
        <div class="taxiAc-coupon-count">X{{ item.couponCount }}</div>
      </div>

      <div class="taxiAcsc-page-footerPhl"> </div>
    </div>

    <div class="taxiAcsc-page-footer">
      <div @click="goPassPage" class="taxiAcsc-page-btn flex-xy-center">{{ $root.getText('bookNow') }}</div>
    </div>

  </div>
</template>

<script>
import { getActivity, receiveCoupon } from "../../../apis/api";
import { sendLoginSms, smsLogin } from "$superAppUser/api/gateway-web/operator/login";
import { getUserInfo, isAndroid, goAppPath, getAppPath, removeUserInfo, goDownloadPage } from '$common/utils/common/common'
import storage from '$common/utils/storage';
import { urlQueries } from '$common/utils/url/url'
import RuleDialog from '../../components/ruleDialog.vue'
import goPassPageMxins from '../../mixins/goPassPage'

export default {
  mixins: [goPassPageMxins],
  documentTitle: {
    i18n: "home.documentTitle"
  },
  data() {
    return {
      couponPackValue: '80,000',
      couponList: [],
      ruleData: null,
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    isWownowApp: () => {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    mainStyle() {
      if (this.$root.clientHeight) {
        return `height: ${this.$root.clientHeight}px;`
      }
      return ''
    },
  },
  mounted() {
    const queries = urlQueries()
    this.activityNo = queries["activityNo"] || queries["i"]
    let data = storage.getItem(`taxiActivityCoupon_${this.activityNo}`);
    if (data) {
      data = JSON.parse(data)
      this.couponList = data.receivedCouponList
      this.ruleData = data.ruleData
    }
  },
  methods: {
    isAmount(item) {
      if (item.discountType === 10) return true
      if (item.discountType && item.discountType.code === 10) return true
      return false
    },
    numFormat(val, unit) {
      if (unit == 'KHR') {
        return Math.floor(val)
      } else {
        return Number(val).toFixed(2)
      }
    },
    moneyFormat(val, unit) {
      if (unit == 'KHR') {
        return `៛${Math.floor(val)}`
      } else {
        return `$${Number(val).toFixed(2)}`
      }
    }
  },
  components: {
    RuleDialog
  }
};

</script>

<style lang="stylus" scoped>
.mr-4 {
  margin-right: 4px;
}

.mr-8{
  margin-right: 8px;
}

.flex-col{
  flex-direction: column;
}

.flex-icenter{
  display: flex;
  align-items: center;
}

.flex-xy-center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.w-f{
  width: 100%;
}

.font-12{
  font-size: 12px;
}
.font-14{
  font-size: 14px;
}


.taxiAc-share-code{
  width: 100%;
}

.taxiAcsc-page{
  height: 100%;
  background-color: #BC2021;
  overflow-x: hidden;
  overflow-y: auto;

  .taxiAcsc-page-title{
    margin-bottom: 10px;
    height: 25px;
    font-weight: 600;
    font-size: 18px;
    color: #fff;
  }

  .taxiAcsc-page-subtitle{
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #fff;
    span{
      display: block;
      margin: 0 4px;
      transform: translateY(-3px);
    }
    strong {
      font-weight: bold;
      font-size: 32px;
    }
  }
}

.taxiAc-coupon-item{
  position: relative;
  padding-left: 32px;
  margin: 0 auto 8px auto;
  width: 291px;
  height: 63px;
  background: url("https://img.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/5441cf7dab3440258aa17cc54378a2d9.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .taxiAc-coupon-amount{
    position: relative;
    margin-top: 12px;
    display: flex;
    align-items: baseline;
    height: 28px;
    strong {
      font-weight: bold;
      font-size: 24px;
      color: #FC2040;
    }
    span {
      display: block;
      margin: 0 3px;
      font-size: 11px;
      font-weight: bold;
      color: #FC2040;
    }
  }
  .taxiAc-coupon-text{
    line-height: 17px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }
  .taxiAc-coupon-count{
    position: absolute;
    top: 22px;
    right: 18px;
    height: 20px;
    font-size: 14px;
    color: #333333;
    z-index: 10;
  }
}

.taxiAc-coupon-preferLimit{
  padding: 0 6px;
  height: 20px;
  background-color: #f9e2d4;
  font-size: 10px;
  color: #FC2040;
  border-radius: 10px;
  transform: translate(-10px, -16px);
}

.taxiAcsc-page-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 91px;
  background: linear-gradient(transparent, #BC2021);
}

.taxiAcsc-page-btn{
  width: 291px;
  height: 56px;
  background: #FFDB39;
  border-radius: 32px;
  font-weight: 600;
  font-size: 16px;
  color: #691818;
  z-index: 10;
  &:active{
    filter: brightness(0.9);
  }
}

.taxiAcsc-page-abaw{
  margin-top: 10px;
  margin-bottom: 25px;
}
.taxiAcsc-page-aba{
  padding: 0 12px;
  height: 18px;
  font-weight: 400;
  font-size: 10px;
  color: #BC2021;
  background: #FFFFFF;
}

.taxiAcsc-page-footerPhl{
  width:  100%;
  height: 150px;
}
</style>
